import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import BASE_URL from "../../../config/config";
import {
  faChevronLeft,
  faChevronRight,
  faEdit,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});
const CreateTeam = () => {
  const [mainHeading, setMainHeading] = useState("");
  const [mainDescription, setMainDescription] = useState("");
  const [isSaved, setIsSaved] = useState(false); // tracks whether the data has been added
  const [headingList, setHeadingList] = useState([]);
  // employee and all
  const [imageList, setImageList] = useState([]);
  const [editIndex, setEditIndex] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);

  const itemsPerPage = 2;
  const totalPages = Math.ceil(imageList.length / itemsPerPage);

  const [formData, setFormData] = useState({
    file: null,
    preview: "",
    alt: "",
    name: "",
    designation: "",
  });

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const preview = URL.createObjectURL(file);
      setFormData((prev) => ({ ...prev, file, preview }));
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };
  // Snackbar states
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success", // success | error | warning | info
  });
  const handleSnackbarClose = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  const handleAddHeading = async () => {
    const token = localStorage.getItem("token");
    if (!mainHeading.trim()) {
      setSnackbar({
        open: true,
        message: "Title is required.",
        severity: "error",
      });
      return;
    }
    try {
      const response = await fetch(`${BASE_URL}/team-heading/create`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          title: mainHeading,
          description: mainDescription,
        }),
      });

      if (response.ok) {
        const savedData = await response.json();
        setHeadingList([...headingList, savedData]);
        setMainHeading("");
        setMainDescription("");
        setIsSaved(false);
        setSnackbar({
          open: true,
          message: "Saved successfully!",
          severity: "success",
        });
      } else {
        setSnackbar({
          open: true,
          message: "Failed to save heading.",
          severity: "error",
        });
      }
    } catch (error) {
      console.error("Save error:", error);
      setSnackbar({
        open: true,
        message: "Server error.",
        severity: "error",
      });
    }
  };

  useEffect(() => {
    axios
      .get(`${BASE_URL}/team-heading/list`, {})
      .then((res) => {
        setHeadingList(res.data.data || []);
      })
      .catch((err) => {
        console.error("Error fetching team headings:", err);
      });
  }, []);

  const deleteHeading = (id) => {
    const token = localStorage.getItem("token");
    axios
      .delete(`${BASE_URL}/team-heading/delete/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then(() => {
        // After successful delete, update the list in state
        setHeadingList((prev) => prev.filter((item) => item.id !== id));
      })
      .catch((err) => {
        console.error("Error deleting heading:", err);
      });
  };

  // this the employee data

  const handleAddOrUpdate = async () => {
    const token = localStorage.getItem("token");

    if (!formData.name || !formData.designation) {
      alert("Name and Designation are required.");
      return;
    }

    const formDataToSend = new FormData();

    if (formData.file instanceof File) {
      formDataToSend.append("file", formData.file); // only append if new image selected
    }

    formDataToSend.append("alt", formData.alt || "");
    formDataToSend.append("name", formData.name);
    formDataToSend.append("designation", formData.designation);

    try {
      let response;

      if (editIndex !== null) {
        // 🟡 UPDATE existing member
        const employeeId = imageList[editIndex].id || imageList[editIndex]._id;

        response = await fetch(`${BASE_URL}/employees/${employeeId}`, {
          method: "PATCH",
          headers: {
            Authorization: `Bearer ${token}`,
          },
          body: formDataToSend,
        });
      } else {
        // 🟢 ADD new member
        response = await fetch(`${BASE_URL}/employees/upload`, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
          },
          body: formDataToSend,
        });
      }

      if (response.ok) {
        const savedData = await response.json();

        alert(
          editIndex !== null ? "Updated successfully!" : "Added successfully!"
        );

        // Refresh employee list
        const listRes = await axios.get(`${BASE_URL}/employees/list`);
        setImageList(listRes.data.data || []);

        // Reset form and state
        setFormData({
          file: null,
          preview: "",
          alt: "",
          name: "",
          designation: "",
        });
        setEditIndex(null);
      } else {
        alert("Failed to save changes. Please try again.");
      }
    } catch (error) {
      console.error("Error:", error);
      alert("Server error. Please try again later.");
    }
  };

  // here is the image view api
  const IMAGE_BASE_URL = `${BASE_URL}/employees/view/`;

  useEffect(() => {
    axios
      .get(`${BASE_URL}/employees/list`)
      .then((res) => {
        setImageList(res.data.data || []); // populate employee data
      })
      .catch((err) => {
        console.error("Error fetching team members:", err);
      });
  }, []);

  const handleEdit = (index) => {
    const item = imageList[index];
    setEditIndex(index);
    setFormData({
      file: null, // don't load old file
      preview: item.fileName ? `${IMAGE_BASE_URL}${item.fileName}` : "",
      alt: item.alt || "",
      name: item.name || "",
      designation: item.designation || "",
    });
  };

  //for the delete
  const handleDelete = (index) => {
    const token = localStorage.getItem("token");
    const itemToDelete = imageList[index];

    if (!itemToDelete || !itemToDelete.id) {
      alert("Item ID not found for deletion.");
      return;
    }

    axios
      .delete(`${BASE_URL}/employees/delete/${itemToDelete.id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then(() => {
        setImageList((prev) => prev.filter((_, i) => i !== index));
        alert("Deleted successfully!");
      })
      .catch((err) => {
        console.error("Delete error:", err);
        alert("Failed to delete item.");
      });
  };

  return (
    <>
      <div className="max-w-6xl mx-auto bg-white p-8 rounded-lg shadow-md">
        <h1 className="text-3xl font-semibold text-main mb-6 text-center">
          Team Management
        </h1>

        {/* title & Description */}

        <div className="mb-6">
          <label className="block font-semibold text-md">Title*</label>
          <input
            type="text"
            value={mainHeading}
            onChange={(e) => setMainHeading(e.target.value)}
            placeholder="Enter title"
            className="w-full p-2 mb-4 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-1 focus:ring-main1 focus:border-main1 transition duration-200"
          />
          <label className="block font-semibold text-md">Description</label>
          <textarea
            value={mainDescription}
            onChange={(e) => setMainDescription(e.target.value)}
            placeholder="Enter main description"
            rows="3"
            className="w-full p-2 mb-4 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-1 focus:ring-main1 focus:border-main1 transition duration-200"
          />
          <button
            onClick={handleAddHeading}
            className="bg-gray-700 w-full text-white px-5 py-2 rounded hover:bg-gray-900"
          >
            {isSaved ? "Update" : "Save"}
          </button>
        </div>

        {/* Title List */}

        {headingList.length > 0 && (
          <div className="mb-10">
            <h2 className="text-2xl font-semibold mb-2">Saved Titles</h2>
            <span className=" text-xs text-red-500">
              note* delete this old heading and titile then add new{" "}
            </span>
            <ul className="space-y-2">
              {headingList.map((item) => (
                <li
                  key={item._id}
                  className="flex justify-between items-start bg-gray-50 p-4 rounded border"
                >
                  <div>
                    <p className="font-bold">{item.title}</p>
                    <p className="text-gray-600">{item.description}</p>
                  </div>
                  <button
                    onClick={() => deleteHeading(item.id)}
                    className="text-red-600 hover:text-red-800"
                    title="Delete Title"
                  >
                    <FontAwesomeIcon icon={faTrash} className="text-md" />
                  </button>
                </li>
              ))}
            </ul>
          </div>
        )}

        {/* Employee Form */}
        <h1 className="text-2xl font-semibold text-main mt-5">
          Employee Detail
        </h1>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 border-t pt-6">
          <div>
            <label className="block text-sm font-medium mb-1">Team Image</label>
            <input
              type="file"
              accept="image/*"
              onChange={handleImageChange}
              className="w-full p-2 mb-4 border border-gray-300 rounded-lg shadow-sm"
            />
            {formData.preview && (
              <img
                src={formData.preview}
                alt="Preview"
                className="w-32 h-32 object-cover mt-3 rounded shadow"
              />
            )}
          </div>
          <div>
            <label className="block text-sm font-medium mb-1">Alt Text</label>
            <input
              type="text"
              name="alt"
              value={formData.alt}
              onChange={handleInputChange}
              className="w-full p-2 mb-4 border border-gray-300 rounded-lg shadow-sm"
            />
            <label className="block text-sm font-medium mb-1">Name</label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleInputChange}
              className="w-full p-2 mb-4 border border-gray-300 rounded-lg shadow-sm"
            />
            <label className="block text-sm font-medium mb-1">
              Designation *
            </label>
            <input
              type="text"
              name="designation"
              value={formData.designation}
              onChange={handleInputChange}
              className="w-full p-2 mb-4 border border-gray-300 rounded-lg shadow-sm"
            />
          </div>
        </div>

        <div className="mt-4">
          <button
            onClick={handleAddOrUpdate}
            className="bg-gray-600 text-white px-6 w-full py-2 rounded hover:bg-gray-800"
          >
            {editIndex !== null ? "Update Member" : "Add Member"}
          </button>
        </div>

        {/* Employee Table with Pagination */}
        {imageList.length > 0 && (
          <div className="mt-10">
            <h2 className="text-2xl font-semibold mb-4">Team Members</h2>
            <div className="overflow-x-auto">
              <table className="min-w-full bg-white border rounded-lg shadow">
                <thead>
                  <tr className="bg-gray-100 text-left">
                    <th className="p-3 border">Image</th>
                    <th className="p-3 border">Alt</th>
                    <th className="p-3 border">Name</th>
                    <th className="p-3 border">Designation</th>
                    <th className="p-3 border text-center">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {imageList
                    .slice(
                      (currentPage - 1) * itemsPerPage,
                      currentPage * itemsPerPage
                    )
                    .map((item, index) => (
                      <tr key={index} className="hover:bg-gray-50">
                        <td className="p-3 border">
                          <img
                            src={
                              item?.fileName
                                ? `${IMAGE_BASE_URL}${item.fileName}`
                                : "/image/default.png"
                            }
                            alt={item.alt}
                            className="w-16 h-16 object-cover rounded"
                          />
                        </td>
                        <td className="p-3 border">{item.alt}</td>
                        <td className="p-3 border">{item.name}</td>
                        <td className="p-3 border">{item.designation}</td>
                        <td className="p-3 border text-center space-x-2">
                          <button
                            onClick={() =>
                              handleEdit(
                                (currentPage - 1) * itemsPerPage + index
                              )
                            }
                            className="text-blue-600 hover:text-blue-800"
                            title="Edit"
                          >
                            <FontAwesomeIcon icon={faEdit} />
                          </button>
                          <button
                            onClick={() =>
                              handleDelete(
                                (currentPage - 1) * itemsPerPage + index
                              )
                            }
                            className="text-red-600 hover:text-red-800"
                            title="Delete"
                          >
                            <FontAwesomeIcon icon={faTrash} />
                          </button>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>

            {/* Pagination */}
            <div className="mt-6 flex justify-center items-center gap-6">
              <button
                onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                disabled={currentPage === 1}
                className={`flex items-center gap-2 px-5 py-2 rounded-full border shadow-sm transition-all duration-300 ${
                  currentPage === 1
                    ? "bg-gray-200 text-gray-500 cursor-not-allowed"
                    : "bg-white text-main hover:bg-main hover:text-white hover:shadow-md"
                }`}
              >
                <FontAwesomeIcon icon={faChevronLeft} className="text-xs" />
                Previous
              </button>

              <span className="text-sm font-medium text-gray-700">
                Page{" "}
                <span className="text-main font-semibold">{currentPage}</span>{" "}
                of <span className="text-main font-semibold">{totalPages}</span>
              </span>

              <button
                onClick={() =>
                  setCurrentPage((prev) => Math.min(prev + 1, totalPages))
                }
                disabled={currentPage === totalPages}
                className={`flex items-center gap-2 px-5 py-2 rounded-full border shadow-sm transition-all duration-300 ${
                  currentPage === totalPages
                    ? "bg-gray-200 text-gray-500 cursor-not-allowed"
                    : "bg-white text-main hover:bg-main hover:text-white hover:shadow-md"
                }`}
              >
                Next
                <FontAwesomeIcon icon={faChevronRight} className="text-xs" />
              </button>
            </div>
          </div>
        )}
      </div>
      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={snackbar.severity}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default CreateTeam;
